/**
 * Log種類
 */
export enum LogType {
  //導入功能後初始路由
  ROUTE_INIT = 'ROUTE_INIT',
  //頁面動作
  PAGE_ACTION = 'PAGE_ACTION',
  //頁面動作-開始
  PAGE_ACTION_START = 'PAGE_ACTION_START',
  //頁面動作-結束
  PAGE_ACTION_END = 'PAGE_ACTION_END',
  //呼叫服務
  SERVICE_ACTION = 'SERVIE_ACTION',
  //呼叫服務-開始
  SERVICE_ACTION_START = 'SERVIE_ACTION_START',
  //呼叫服務-結束
  SERVICE_ACTION_END = 'SERVIE_ACTION_END',
  //業務檢核
  BUSINESS_CHECK = 'BUSINESS_CHECK',
  //業務檢核-開始
  BUSINESS_CHECK_START = 'BUSINESS_CHECK_START',
  //業務檢核-結束
  BUSINESS_CHECK_END = 'BUSINESS_CHECK_END',
  //呼叫API request
  HTTP_REQUEST = 'HTTP_REQUEST',
  //呼叫API response
  HTTP_RESPONSE = 'HTTP_RESPONSE',
  //非預期錯誤
  EXCEPTION_ERROR = 'EXCEPTION_ERROR',
}
